import React from 'react'
import ReactContentLoader, { IContentLoaderProps } from 'react-content-loader'
import classNames from 'classnames'
import { getDirMode } from 'mobile_web/modules/platform'

import './styles/ContentLoader.less'

const ContentLoader: React.FC<IContentLoaderProps> = (props): JSX.Element => {
	const dirMode = getDirMode()

	return (
		<ReactContentLoader
			speed={2}
			width="100%"
			height="100%"
			foregroundOpacity={0.12}
			preserveAspectRatio="none"
			{...props}
			className={classNames('content-loader', dirMode)}
			backgroundColor="var(--placeholder-bg)"
			foregroundColor="var(--placeholder-foreground)"
		>
			{props.children}
		</ReactContentLoader>
	)
}

export default ContentLoader
